// Belmont University's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from the
// official Undergraduate Catalog 2026-2027, Undergraduate Programs page
// (catalog.belmont.edu, catoid=21), which groups programs by the degree they lead to;
// the groups here follow it. Every program under a bachelor's degree heading is kept,
// including the 3+3 and 4+1 pathways the catalog lists there; endorsements, licenses,
// minors and graduate programs are left out. "B.A./B.S." reads "B.A. or B.S.", and the
// catalog's ampersands are written as "and". The catalog page sits behind a bot check,
// so it was read in a headless browser.
const majors = {
    "slug": "belmont-university",
    "read": "2026-10-01",
    "intro": "Every program Belmont's official 2026-2027 Undergraduate Catalog lists under a bachelor's degree, grouped by that degree. Minors, endorsements and graduate programs are left out.",
    "groups": [
        {
            "name": "Bachelor of Architecture",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch."
                }
            ]
        },
        {
            "name": "Bachelor of Arts",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Bible and Theology",
                    "degree": "B.A."
                },
                {
                    "name": "Christian Leadership",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Faith and Social Justice 4+1, B.A. to M.S.W.",
                    "degree": null
                },
                {
                    "name": "Faith and Social Justice",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music, Emphasis in Musical Theatre Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Photographic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Teaching English as a Second Language (pre-K-12)",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre and Drama",
                    "degree": "B.A."
                },
                {
                    "name": "Worship and the Arts",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Bachelor of Arts/Bachelor of Science",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Audio Engineering Technology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Biophysics",
                    "degree": "B.S. or B.A."
                },
                {
                    "name": "Chemical and Biological Health Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Cinema and Television Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Corporate Communication",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Early Childhood Education, Pre K-3 License",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Education Policy",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S. or B.A."
                },
                {
                    "name": "Film and Television Writing",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Global Leadership Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "History and Public Policy",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "International Politics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Media and Entertainment Industries",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Media Production",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Middle School Education",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Ministry",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Ministry, Evening",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Motion Picture Production",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S. or B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Politics and Public Law",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Psychological Science",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Psychological Sciences, B.A./B.S. to Doctor of Occupational Therapy 3+3 Program",
                    "degree": null
                },
                {
                    "name": "Public Advocacy",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Public Relations Management",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Publishing",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Social Entrepreneurship",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Social Media Management",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Songwriting",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Special Education Interventionist K-8",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Sport Administration",
                    "degree": "B.A. or B.S."
                }
            ]
        },
        {
            "name": "Bachelor of Business Administration",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.B.A."
                },
                {
                    "name": "Music Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Professional, Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Professional, General Business",
                    "degree": "B.B.A."
                }
            ]
        },
        {
            "name": "Bachelor of Fine Arts",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Animation and Media Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Architectural Studies",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art Education",
                    "degree": "B.F.A."
                },
                {
                    "name": "Design Communications",
                    "degree": "B.F.A."
                },
                {
                    "name": "Experiential Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Fashion Business and Design Leadership",
                    "degree": "B.F.A."
                },
                {
                    "name": "Fashion Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Illustration",
                    "degree": "B.F.A."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Motion Picture Production",
                    "degree": "B.F.A."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Photography",
                    "degree": "B.F.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "Bachelor of Music",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Church Music",
                    "degree": "B.M."
                },
                {
                    "name": "Commercial Music, Instrumental",
                    "degree": "B.M."
                },
                {
                    "name": "Commercial Music, Vocal",
                    "degree": "B.M."
                },
                {
                    "name": "Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education, Instrumental License",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education, Vocal License",
                    "degree": "B.M."
                },
                {
                    "name": "Music Technology",
                    "degree": "B.M."
                },
                {
                    "name": "Music Theory",
                    "degree": "B.M."
                },
                {
                    "name": "Music Therapy, Instrument",
                    "degree": "B.M."
                },
                {
                    "name": "Music Therapy, Keyboard",
                    "degree": "B.M."
                },
                {
                    "name": "Music Therapy, Vocal",
                    "degree": "B.M."
                },
                {
                    "name": "Music with an Outside Minor",
                    "degree": "B.M."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.M."
                },
                {
                    "name": "Performance, Piano, Organ, Guitar, Instruments",
                    "degree": "B.M."
                },
                {
                    "name": "Performance, Vocal",
                    "degree": "B.M."
                },
                {
                    "name": "Piano Pedagogy",
                    "degree": "B.M."
                }
            ]
        },
        {
            "name": "Bachelor of Science",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science 3 + 3 Program",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Pharmaceutical Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Psychological Science, B.S. to M.S.W. 4+1 Program",
                    "degree": "B.S."
                },
                {
                    "name": "Public Advocacy 4+1, B.S. to M.S.W.",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Bachelor of Science in Nursing",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "Bachelor of Science in Public Health",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "B.S.P.H."
                }
            ]
        },
        {
            "name": "Bachelor of Social Work",
            "source": {
                "label": "Belmont Undergraduate Catalog 2026-2027, Undergraduate Programs",
                "url": "https://catalog.belmont.edu/content.php?catoid=21&navoid=1170"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        }
    ]
};

export default majors;
